import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=eef2634e&scoped=true&"
import script from "./MegaMenu.vue?vue&type=script&lang=ts&"
export * from "./MegaMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MegaMenu.vue?vue&type=style&index=0&id=eef2634e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eef2634e",
  null
  
)

export default component.exports